import axios from 'axios';

axios.defaults.timeout = 50000;
axios.defaults.baseURL = 'https://topsfilm.com/api/api';


//http request 拦截器
axios.interceptors.request.use(
  config => {
    // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
    config.data = config.data;
    config.headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
      //'Content-Type':'application/json;charset=UTF-8'
    }
    // if(token){
    //   config.params = {'token':token}
    // }
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);


//http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.errCode == 2) {
      router.push({
        path: "/main",
        querry: {
          redirect: router.currentRoute.fullPath
        } //从哪个页面跳转
      })
    }
    return response;
  },
  error => {
    return Promise.reject(error)
  }
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function httpGet(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}
export function omsGetWarranties(params = {}){
  return new Promise((resolve, reject) => {
    axios.get('https://omsapi.topsfilm.com/api/v1/CarFilmWarranty/GetWarranties', {
        params: params
      })
      .then(response => {
        resolve(response.data.data.dataList);
      })
      .catch(err => {
        reject(err)
      })
  })
}
export function GetListByCityCode(params = {}){
  return new Promise((resolve, reject) => {
    axios.get('https://omsapi.topsfilm.com/api/v1/BusinessDealer/GetListByCityCode', {
        params: params
      })
      .then(response => {
        resolve(response.data.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 获取新闻列表
 * @param params
 * @returns {Promise}
 */
export function GetNewsList(params = {}){
  return new Promise((resolve, reject) => {
    axios.get('https://omsapi.topsfilm.com/api/v1/AppSiteNews/GetList', {
        params: params
      })
      .then(response => {
        resolve(response.data.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 获取新闻详情
 * @param params
 * @returns {Promise}
 */
export function GetNewsDetail(params = {}){
  return new Promise((resolve, reject) => {
    axios.get('https://omsapi.topsfilm.com/api/v1/AppSiteNews/Get', {
        params: params
      })
      .then(response => {
        resolve(response.data.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function httpPost(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}


/***************** 调用示例 ******************

this.$httpGet('http://ry.smsoft365.com:1880/sqk_shop.asq')
				.then((response) => {
					console.log(response)
				});

***************** 调用示例 ******************/



//////////////////
// WEBPACK FOOTER
// ./http.js
// module id = 6402
// module chunks = 42